// frontend\src\pages\AboutPage\ImageModal.js
import { useEffect, useCallback, useState } from "react";

const ImageModal = ({ image, onClose }) => {
  const [imageSize, setImageSize] = useState({ width: 0, height: 0 });

  const handleKeyDown = useCallback((e) => {
    if (e.key === 'Escape') {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    if (!image) return;

    const updateSizes = () => {
      const maxWidth = window.innerWidth - 100;
      const maxHeight = window.innerHeight - 100;

      const img = new Image();
      img.onload = () => {
        let displayWidth = img.width;
        let displayHeight = img.height;

        if (displayWidth > maxWidth || displayHeight > maxHeight) {
          const widthRatio = maxWidth / displayWidth;
          const heightRatio = maxHeight / displayHeight;
          const ratio = Math.min(widthRatio, heightRatio);
          
          displayWidth = Math.floor(displayWidth * ratio);
          displayHeight = Math.floor(displayHeight * ratio);
        }

        setImageSize({
          width: displayWidth,
          height: displayHeight
        });
      };
      img.src = image.src;
    };

    updateSizes();
    window.addEventListener('resize', updateSizes);
    
    return () => {
      window.removeEventListener('resize', updateSizes);
    };
  }, [image]);

  useEffect(() => {
    if (!image) return;

    document.addEventListener('keydown', handleKeyDown);
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [image, handleKeyDown]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  if (!image) return null;

  return (
    <div 
      className="image-modal-backdrop"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        zIndex: 9999,
        cursor: 'zoom-out',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}
      onClick={handleBackdropClick}
    >
      <div 
        className="image-modal-content"
        style={{ 
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onClick={handleContentClick}
      >
        {/* Контейнер для изображения */}
        <div 
          className="image-container"
          style={{
            backgroundColor: '#ffffff',
            borderRadius: '8px',
            boxShadow: '0 10px 40px rgba(0,0,0,0.5)',
            width: `${imageSize.width}px`,
            height: `${imageSize.height}px`,
            maxWidth: '100%',
            maxHeight: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'default',
            overflow: 'hidden'
          }}
        >
          <img
            src={image.src}
            alt={image.alt || ''}
            style={{
              width: 'auto',
              height: 'auto',
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              display: 'block',
              borderRadius: '8px'
            }}
          />
        </div>

        {/* Кнопка закрытия - с !important стилями чтобы перебить тему */}
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '-20px',
            right: '-20px',
            width: '50px',
            height: '50px',
            backgroundColor: '#ffffff !important',
            border: 'none !important',
            borderRadius: '50%',
            color: '#000000 !important',
            fontSize: '24px',
            fontWeight: 'bold',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1,
            transition: 'all 0.2s ease',
            boxShadow: '0 4px 15px rgba(0,0,0,0.6) !important',
            opacity: '1 !important'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#ffffff !important';
            e.target.style.transform = 'scale(1.1)';
            e.target.style.opacity = '1 !important';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#ffffff !important';
            e.target.style.transform = 'scale(1)';
            e.target.style.opacity = '1 !important';
          }}
        >
          <i className="bi bi-x"></i>
        </button>
      </div>
    </div>
  );
};

export default ImageModal;